import React, { FC } from 'react';
import styled from 'styled-components';
import { Assign } from 'utility-types';
import { globalTheme } from '@clds/component-theme';
import { Card, CardProps } from '@cld/card';
import ItemLayout from '@cld/list-item-layout';
import { theme } from './theme';

type CardPartialProps = 'selected' | 'size';

const StyledCard = styled(Card)`
  width: 100%;
  height: ${theme.height};
  padding: ${globalTheme.spacing.xs} ${globalTheme.spacing.sm};
  font-size: ${globalTheme.font.size.xxs};

  svg:first-child {
    width: ${theme.icon.size};
    height: ${theme.icon.size};
    flex-shrink: 0;
  }
`;

export type FolderCardProps = Assign<CardProps, Pick<CardProps, CardPartialProps>>;

export const FolderCard: FC<React.PropsWithChildren<FolderCardProps>> = ({ size = 'md', children, ...rest }) => (
  <StyledCard size={size} {...rest}>
    <ItemLayout size={size}>{children}</ItemLayout>
  </StyledCard>
);
